export abstract class CircularRandom{
    randomConfig;

    init(randomConfig){
        this.randomConfig = randomConfig;
    }

    abstract generateRandomNodes(nodeList, rootNode)

}